export default {
  namespaced: true,
  state: () => ({
    listaUsuarios: [],
    itemUsuario: {},
    setIsLoading: false,
  }),
  actions: {
  },
  mutations: {
    SET_LISTA_USUARIOS(state, data) {
      state.listaUsuarios = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },

    SET_LISTA_USUARIO(state, data) {
      state.itemUsuario = data;
    },

  },
  getters: {
    getListaUsuarios: (state) => state.listaUsuarios,
    getIsLoading: (state) => state.setIsLoading,
    getItemUsuario: (state) => state.itemUsuario,
  },
};
